<template>
  <div id="app" v-cloak v-show="loading">
<!--    commomHide-->
    <common-header ref="header" v-show="$route.name == 'microVideo'?false:true"/>
    <router-view />
    <common-footer v-show="$route.name == 'microVideo'?false:true"/>
    <back-top />
  </div>
</template>

<script>
  import commonHeader from "@/components/layout/common/header";
  import backTop from "@/components/backtop";
  import commonFooter from '@/components/layout/common/footer';
  export default {
    name: 'App',
    components:{ commonHeader,commonFooter,backTop },
    data(){
      return{
        loading: false,
        load:'',
      }
    },
    mounted() {
      // this.loading = false
      // console.log(this.$route)
      setTimeout(()=> {
        this.loading = true
        this.load.close()
      },1000)
    },
    created() {
      this.load = this.$loading();
    },
    methods:{
      backtop(){
        document.getElementById('app').scrollIntoView()
      },
      _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
      }
    }
  }
</script>

<style>
  .bottom-padding{
    padding-bottom: 3rem;
  }
  .el-loading-mask{
    background-color: rgba(255,255,255,1);
  }
  .content{
    padding: 1.8rem 3.8rem;
    padding-bottom: 0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    /*color: #2c3e50;*/
    /*margin-top: 60px;*/
    color: #262728;
  }
  @media only screen and (max-width: 767px){
    #app{
      /*overflow: hidden;*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue